import { render, staticRenderFns } from "./MaintenanceViewDocuments.vue?vue&type=template&id=ecbabbb8"
import script from "./MaintenanceViewDocuments.vue?vue&type=script&lang=js"
export * from "./MaintenanceViewDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports